import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M6.45637 0C6.75932 0 7.03252 0.182259 7.14886 0.461977L8.55996 3.85466L12.2226 '
  + '4.1483C12.5246 4.17251 12.7824 4.37601 12.876 4.66413C12.9696 4.95226 12.8807 5.26841 12.6506 '
  + '5.46549L9.86005 7.85592L10.7126 11.4301C10.7829 11.7248 10.669 12.0328 10.4239 12.2109C10.1788 '
  + '12.3889 9.85068 12.4021 9.59214 12.2442L6.45637 10.3288L3.3206 12.2442C3.06206 12.4021 2.73391 '
  + '12.3889 2.48882 12.2109C2.24373 12.0328 2.12984 11.7248 2.20013 11.4301L3.0527 7.85592L0.262115 '
  + '5.46549C0.0320386 5.26841 -0.0568759 4.95226 0.0367403 4.66413C0.130357 4.37601 0.388118 4.17251 '
  + '0.690098 4.1483L4.35278 3.85466L5.76388 0.461977C5.88022 0.182259 6.15342 0 6.45637 0Z'

const StarIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 12.9127 12.3541" xmlns="http://www.w3.org/2000/svg">
    <path clipRule="evenodd" d={PATH} fill="currentColor" fillRule="evenodd" />
  </svg>
)

StarIcon.propTypes = {
  className: PropTypes.string
}

StarIcon.defaultProps = {
  className: 'tw:h-3 tw:w-3'
}

export default StarIcon
